import { Component, OnInit, Input } from '@angular/core';
import { AppPageService } from '../app-page/app-page.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifc-app-scroll-container',
    templateUrl: './app-scroll-container.component.html',
    styleUrls: ['./app-scroll-container.component.scss'],
    standalone: false
})
export class AppScrollContainerComponent implements OnInit {
  appBarExpanded: boolean;
  @Input() widgetsWithTopHeader: boolean;
  @Input() default: boolean;
  @Input() tabbed: boolean;
  @Input() innerTabbedHidden: boolean;
  @Input() innerTabbedVisible: boolean;
  @Input() filtered: boolean;
  @Input() detailTabbed: boolean;
  @Input() layout2: boolean;
  @Input() layout2List: boolean;
  @Input() layout2ListFiltered: boolean;
  @Input() innerSidenav: boolean;
  @Input() innerSidenavAndList: boolean;
  @Input() innerSidenavAndTabbed: boolean;

  constructor( private appPageService: AppPageService) { }

  ngOnInit() {
    this.appPageService.obsAppBarExpanded
      .pipe(untilDestroyed(this))
      .subscribe((value: boolean) => {
        this.appBarExpanded = value;
      });
  }
}

